/**
 * 信息提示动画
 */
import fvAnimation from "./fvAnimation"
export default class fvMessage extends fvAnimation {
    constructor(shape){
        super(shape,"fvMessage");
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }

    async run(event,show){
        var size = await this.executionScript(this.sizeFunction);
        if(show == true){
            this.shape.fvScript.system.tooltip.$.show(true,event,size);
            this.shape.fvScript.system.tooltip.$.move(event);
        }else{//移出关闭
            this.shape.fvScript.system.tooltip.$.show(false,event,size); 
        }
      }

}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvMessage.js